import React from 'react';
import styles from './styles.scss';
import loader from '../../../images/loader.gif'

export default ({ message }: Props) => {
  return (
    <div className={styles.statusScreen}>
      {message && <p>{message}</p>}
      <img src={loader} alt="loading" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/LoaderScreen/index.js